<template>
  <div class="surface-post-comments">
    <div v-if="commentsList.length > 0" class="comments-list tv-list">
      <div class="tv-cell caption-type small-type comments-summary">
        {{ n__('%{num} comment', '%{num} comments', commentsList.length, { num: commentsList.length }) }}
      </div>
      <surface-post-comment
        v-for="comment in commentsList"
        :id="comment.id"
        :key="comment.id"
        :is-being-edited="commentBeingEditedId === comment.id"
        :comment="comment"
        :author="comment.user"
        @show-comment-action-menu="$emit('show-comment-action-menu', { commentId: comment.id })"
        @stop-editing="$emit('stop-editing')"
        @edit="$emit('edit', $event)"
      />
    </div>
    <div v-if="isCommentable" class="add-comment">
      <div class="avatar"><avatar-image :user="user" width="16" height="16" :alt="__('Your avatar')" /></div>
      <div class="textarea-wrapper">
        <multiline-input
          ref="addCommentInput"
          v-model="newCommentBody"
          dir="auto"
          class="add-comment-input"
          :placeholder="__('Add comment')"
          :title="__('Add comment')"
          :data-value="blankCommentValue"
          @focus="onAddCommentFocus"
          @blur="onAddCommentBlur"
          @enter="submit"
        />
      </div>
      <button v-if="isAddCommentFocused" type="submit" class="icon-button" @mousedown="onAddCommentSubmitClicked">
        <base-icon size="small" name="forward_button" />
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapActions } from 'vuex'
import { $ } from 'bits/jquery'
import IntlMixin from 'vuemixins/intl_mixin'
import BaseIcon from 'vuecomponents/base_icon'
import SurfacePostComment from 'vuecomponents/surface_post_comment'
import MultilineInput from 'vuecomponents/multiline_input'
import AvatarImage from 'vuecomponents/avatar_image'

export default {
  components: {
    AvatarImage,
    BaseIcon,
    SurfacePostComment,
    MultilineInput,
  },
  mixins: [IntlMixin],
  props: {
    post: { type: Object, default: null },
    user: { type: Object, default: null },
    commentIds: { type: Array, default: null },
    comments: { type: Object, default: null },
    isCommentable: { type: Boolean },
    commentBeingEditedId: { type: Number, default: null },
  },
  data() {
    return {
      newCommentBody: '',
      blankCommentValue: '',
      isAddCommentFocused: false,
    }
  },
  computed: {
    commentsList() {
      return this.commentIds.map(id => this.comments[id])
    },
  },
  methods: {
    ...mapActions('comment', ['addCommentInputFocused', 'addCommentInputBlurred']),
    showCommentActionMenu($event) {
      this.$emit('show-comment-action-menu', $event)
    },
    stopEditingComment() {
      this.$emit('stop-editing')
    },
    editComment($event) {
      this.$emit('edit', $event)
    },
    publishComment() {
      if (this.newCommentBody) {
        this.$emit('create', {
          postId: this.post.id,
          body: this.newCommentBody,
        })
        this.newCommentBody = ''
        setTimeout(() => {
          $(this.$refs.addCommentInput).focus()
        })
      }
      this.blankCommentValue = ''
    },
    submit() {
      this.publishComment()
    },
    onAddCommentFocus() {
      this.isAddCommentFocused = true
      this.addCommentInputFocused({ postId: this.post.id })
    },
    onAddCommentBlur() {
      this.isAddCommentFocused = false
      this.addCommentInputBlurred({ postId: this.post.id })
    },
    onAddCommentSubmitClicked() {
      this.publishComment()
    },
  },
}
</script>

<style lang="scss" scoped>
$lighter-grey-post-color: #2c2c2c;

.surface-post-comments {
  background-color: rgba(black, 0.04);
  display: block;

  [data-color-scheme='dark'] & {
    background: $lighter-grey-post-color;
  }

  .add-comment {
    padding: 4px 4px 4px 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .avatar {
      margin: 6px 0;
      img {
        border-radius: 16px;
        margin-right: 0.5em;
        display: block;
      }
    }

    .textarea-wrapper {
      margin: 4px 0px;
      flex-grow: 1;

      .add-comment-input {
        font-size: 12px;
        margin-bottom: 0;
      }
    }

    .icon-button {
      margin: 3px 0px;
    }
  }
}
</style>
